import React from "react";
import Box from "@mui/material/Box/Box";
import { Add, Remove } from "@mui/icons-material";
import Button from "@mui/material/Button";
import GenieText from "../genie-text/GenieText";
import { CircularProgress, MenuItem, Select } from "@mui/material";
import { Nullable } from "../../../utils/Nullable";
import useCurrentCart from "../../../queries/routes/useCurrentCart";
import useUser from "../../../queries/routes/useUser";
import { useParams } from "react-router-dom";
import { MAX_QUANTITY } from "../../../routes/store/pdp/Pdp";

interface GenieStepperProps {
  quantity: Nullable<number>;
  remove: () => void;
  add: (quantity?: number) => void;
  loading?: boolean;
}

const quantityMap = new Array(MAX_QUANTITY).fill(0).map((_, i) => i);

function GenieStepper({ quantity, add, remove, loading }: GenieStepperProps) {
  const { org_id } = useParams();
  const { data: user } = useUser();
  const { data: cart } = useCurrentCart(org_id!, user?.organizations[0].id!);
  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      border={"1px solid"}
      borderRadius={1}
      borderColor="grey.300"
      sx={{ cursor: "auto" }}
      height={"40px"}
    >
      <Button
        disabled={loading || quantity === 0}
        size={"small"}
        sx={{
          minWidth: 16,
          cursor: loading || quantity === 0 ? "not-allowed" : "curser",
          height: "100%",
        }}
        variant={"text"}
        color="primary"
        onClick={(event) => {
          event.stopPropagation();
          remove();
        }}
      >
        <Remove fontSize={"small"} />
      </Button>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        justifyContent={"center"}
      >
        {quantity === 0 && cart ? (
          <Button
            disabled={loading}
            size={"small"}
            fullWidth
            sx={{
              height: "100%",
            }}
            onClick={(event) => {
              event.stopPropagation();
              add();
            }}
          >
            Add to cart
          </Button>
        ) : (
          <GenieText
            style={{
              cursor: "auto",
              minWidth: 32,
              width: "100%",
              textAlign: "center",
            }}
            fontSize={"tiny"}
          >
            {loading || !quantity ? (
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <CircularProgress size={16} />
              </Box>
            ) : (
              <Select
                value={quantity}
                size={"small"}
                variant={"standard"}
                IconComponent={() => null}
                onAbort={(event) => {
                  event.stopPropagation();
                }}
                onClose={(event) => {
                  event.stopPropagation();
                }}
                sx={{
                  fontSize: "14px",
                  flexGrow: 1,
                  width: "100%",
                  border: "none",
                  height: "40px",
                  "&:before": {
                    border: "none !important",
                  },
                  "> div": {
                    padding: "0 !important",
                    "&:focus": {
                      backgroundColor: "transparent !important",
                    },
                  },
                }}
                onChange={(event) => {
                  event.stopPropagation();
                  add(event.target.value as number);
                }}
              >
                {quantityMap.map((q) => (
                  <MenuItem
                    key={q}
                    onAbort={(event) => {
                      event.stopPropagation();
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    value={q}
                  >
                    {q}
                  </MenuItem>
                ))}
              </Select>
            )}
          </GenieText>
        )}
      </Box>
      <Button
        disabled={loading}
        sx={{ minWidth: 16, height: "100%" }}
        variant={"text"}
        size={"small"}
        color="primary"
        onClick={(event) => {
          event.stopPropagation();
          add();
        }}
      >
        <Add fontSize={"small"} />
      </Button>
    </Box>
  );
}

export default GenieStepper;
